import React, { useCallback, useEffect, useState } from "react";
import { API, authHeaders, jsonAuthHeaders } from "../services/config";
import "./Seguimiento.css";
import EmptyState from "./ui/EmptyState";

function todayLocalISO() {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export default function Seguimiento({ pacienteId, onClose, onSaved, embedded = false }) {
  const [fecha, setFecha] = useState(todayLocalISO);
  const [comentario, setComentario] = useState("");
  const [historial, setHistorial] = useState([]);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchHistorial = useCallback(async () => {
    if (!pacienteId) return;
    const response = await fetch(`${API}/pacientes/${pacienteId}/seguimientos`, { headers: authHeaders() });
    const data = await response.json();
    if (response.ok && data.success) setHistorial(data.data || []);
  }, [pacienteId]);

  useEffect(() => {
    fetchHistorial();
  }, [fetchHistorial]);

  const handleGuardar = async () => {
    if (!fecha || !comentario.trim()) return;
    setLoading(true);
    try {
      let url = `${API}/seguimientos`;
      let method = "POST";
      if (editId) {
        url = `${API}/seguimientos/${editId}`;
        method = "PUT";
      }

      const response = await fetch(url, {
        method,
        headers: jsonAuthHeaders(),
        body: JSON.stringify({
          paciente_id: pacienteId,
          fecha,
          comentario,
        }),
      });

      if (response.ok) {
        setEditId(null);
        setFecha(todayLocalISO());
        setComentario("");
        fetchHistorial();
        if (typeof onSaved === "function") onSaved();
      }
    } finally {
      setLoading(false);
    }
  };

  const handleEditar = (item) => {
    setEditId(item.id);
    setFecha(item.fecha);
    setComentario(item.comentario);
  };

  const handleEliminar = async (id) => {
    if (!window.confirm("¿Eliminar seguimiento?")) return;
    const response = await fetch(`${API}/seguimientos/${id}`, {
      method: "DELETE",
      headers: authHeaders(),
    });
    if (response.ok) {
      setHistorial((prev) => prev.filter((item) => item.id !== id));
      if (typeof onSaved === "function") onSaved();
    }
  };

  return (
    <div className={embedded ? "seguimiento-embedded" : "seguimiento-overlay"}>
      <div className="seguimiento-modal">
        <h2 className="seguimiento-titulo-principal">Seguimiento clínico</h2>
        <div className="seguimiento-composer pp-card">
          <input type="date" value={fecha} className="input-fecha" onChange={(e) => setFecha(e.target.value)} />
          <textarea
            value={comentario}
            onChange={(e) => setComentario(e.target.value)}
            placeholder="Registrar evolución, novedades o pautas del paciente..."
            className="seguimiento-textarea"
          />
          <div className="seguimiento-botones">
            {!embedded && <button type="button" className="boton-secundario" onClick={onClose}>Cerrar</button>}
            <button type="button" className="pp-btn-guardar" onClick={handleGuardar} disabled={loading}>
              {loading ? "Guardando..." : (editId ? "Guardar cambios" : "Agregar nota")}
            </button>
          </div>
        </div>

        <h3 className="historial-titulo">Timeline</h3>
        <div className="historial-lista timeline">
          {historial.length === 0 ? (
            <EmptyState title="Sin registros" description="Todavía no hay seguimientos cargados." />
          ) : (
            historial.map((item) => (
              <div key={item.id} className="historial-item timeline-item">
                <div className="historial-fecha">{item.fecha}</div>
                <div className="historial-comentario">{item.comentario}</div>
                <div className="acciones">
                  <button type="button" className="boton-secundario" onClick={() => handleEditar(item)}>Editar</button>
                  <button type="button" className="pp-btn-cerrar" onClick={() => handleEliminar(item.id)}>Eliminar</button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
